import { Button } from "frontend-components";
import { useFormContext } from "../form-context";
import { useTranslation } from "react-i18next";

export function FormSubmitButton() {
    const form = useFormContext();
    const { t } = useTranslation();
    return (
        <form.Subscribe selector={(state) => [state.isValid, state.isSubmitting, state.isDirty]}>
            {([isValid, isSubmitting, isDirty]) => (
                <div className="sticky bottom-0 z-50 col-span-2 -mx-4 flex justify-end border-t bg-white border-gray-200 p-4">
                    {" "}
                    <Button
                        type="submit"
                        variant="submit"
                        disabled={!isValid || isSubmitting || !isDirty}
                    >
                        {isSubmitting ? t("userSelector.starting") : t("userSelector.start")}
                    </Button>
                </div>
            )}
        </form.Subscribe>
    );
}
